export default {
	'graphsexport':false,
	'download': false,
	'archives': false,
	'streamPopover':{
		'enabled': true,
		'audio': true,
		'video': true,
	},
	'realtime': true,
	'measurement': {
		'enabled': true,
		'measurement': false, 
	},
	'settings':{
		'enabled': false,
		'interface':false,
		'download':false,
		'audioRecording': false,
		'dynamicDns':{
			'enabled': false,
			'address': false,
			'provider': false,
			'username': false,
			'password': false,
			'ip': false
		},
		'alertMessaging':{
			'enabled': false,
			'emailsett': false,
			'sender': false,
			'password': false,
			'smtp': false
		},
		'FTPSending':{
			'enabled': false,
			'address': false,
			'refresh': false,
			'username': false,
			'password': false,
			'port': false,
			'values': false,
			'zipped': false,
		},
		'geographicPosition':false,
		'weather':false,
		'delete':false,
		'device':false,
		'video':false,
		'adio':false,
		'norcloud':false,
		'status': {
			'enabled': false,
			'gauges': false,
			'logs': false,
			'users': false,
			'userAdmin': false,
			'userOper': false,
			'userGuest': false,
		}
	},
}


// WEBPACK FOOTER //
// ./src/users/guest.js